import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  jobsPage: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height: '100vh',
  },
  jobsContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default useStyles;
